import React from 'react';
import { Button } from '@material-ui/core';

import { TableCellDate } from 'components/table-cell/date';
import { TableCellText } from 'components/table-cell/text-cell';
import { TableColumn } from 'components/table/table-types';

import { LentTableActionCell } from './history/lent-table-action-cell';
import { extensionCellFactory } from './lent-extension-cell';

export const lentDigitalColumns: TableColumn[] = [
  {
    id: 'numericId',
    label: 'Identifikátor archiválie',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.archivalCollection.mark',
    label: 'Značka AS',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.summary',
    label: 'Obsah archiválie',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.timeRange',
    label: 'Časový rozsah',
    CellComponent: TableCellText,
  },
  {
    id: 'aisOrder.researchSheet.ordinalNumber',
    label: 'Číslo BL',
    CellComponent: TableCellText,
  },
  {
    id: 'expiration',
    label: 'Zpřístupněno do',
    CellComponent: TableCellDate,
  },
  {
    id: 'id',
    label: 'Detail',
    CellComponent: function CopyLink({ data }) {
      return (
        <Button
          variant="contained"
          color="primary"
          size="small"
          href={`${process.env.PUBLIC_URL}/soukrome-archivalie/0/${data}`}
        >
          Otevřít
        </Button>
      );
    },
    disableSort: true,
  },
  {
    id: 'requestedExtensionTo',
    label: 'Žádost o prodloužení vypůjčení',
    CellComponent: extensionCellFactory({
      archivalUnitType: 'PrivateArchivalUnit',
    }),
    disableSort: true,
  },
];

export const lentPhysicalColumns: TableColumn[] = [
  {
    id: 'archivalUnitReference.numericId',
    label: 'Identifikátor archiválie',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.archivalCollection.mark',
    label: 'Značka fondu',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.summary',
    label: 'Obsah archiválie',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.timeRange',
    label: 'Časový rozsah',
    CellComponent: TableCellText,
  },
  {
    id: 'aisOrder.researchSheet.ordinalNumber',
    label: 'Číslo BL',
    CellComponent: TableCellText,
  },
  {
    id: 'privateCopy.id',
    label: 'Detail',
    CellComponent: function CopyLink({ data }) {
      return (
        <Button
          variant="contained"
          color="primary"
          size="small"
          href={`${process.env.PUBLIC_URL}/soukrome-archivalie/0/${data}`}
          disabled={!data}
        >
          Otevřít
        </Button>
      );
    },
    disableSort: true,
  },
  {
    id: 'expiration',
    label: 'Rezervováno do',
    CellComponent: TableCellDate,
  },
  {
    id: 'requestedExtensionTo',
    label: 'Žádost o prodloužení vypůjčení',
    CellComponent: extensionCellFactory({
      archivalUnitType: 'ArchivalUnitReservation',
    }),
    disableSort: true,
  },
];

export const lentHistoryPhysicalColumns: TableColumn[] = [
  {
    id: 'archivalUnitReference.numericId',
    label: 'Identifikátor archiválie',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.archivalCollection.mark',
    label: 'Značka AS',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.summary',
    label: 'Obsah archiválie',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.timeRange',
    label: 'Časový rozsah',
    CellComponent: TableCellText,
  },
  {
    id: 'firstLent',
    label: 'První vypůjčení',
    CellComponent: TableCellDate,
  },
  {
    id: 'lastLent',
    label: 'Poslední vypůjčení',
    CellComponent: TableCellDate,
  },
  {
    id: 'latestPrivateCopy.id',
    label: 'Detail',
    CellComponent: function CopyLink({ data }) {
      return (
        <Button
          variant="contained"
          color="primary"
          size="small"
          href={`${process.env.PUBLIC_URL}/soukrome-archivalie/0/${data}`}
          disabled={!data}
        >
          Otevřít
        </Button>
      );
    },
    disableSort: true,
  },
  {
    id: 'action',
    label: 'Akce',
    disableSort: true,
    CellComponent: LentTableActionCell,
  },
];

export const lentHistoryDigitalColumns: TableColumn[] = [
  {
    id: 'archivalUnitReference.numericId',
    label: 'Identifikátor archiválie',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.archivalCollection.mark',
    label: 'Značka AS',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.summary',
    label: 'Obsah archiválie',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.timeRange',
    label: 'Časový rozsah',
    CellComponent: TableCellText,
  },
  {
    id: 'firstExported',
    label: 'První zpřístupnění',
    CellComponent: TableCellDate,
  },
  {
    id: 'expired',
    label: 'Expirováno',
    CellComponent: TableCellDate,
  },
  {
    id: 'latestPrivateCopy.id',
    label: 'Detail',
    CellComponent: function CopyLink({ data }) {
      return (
        <Button
          variant="contained"
          color="primary"
          size="small"
          href={`${process.env.PUBLIC_URL}/soukrome-archivalie/0/${data}`}
          disabled={!data}
        >
          Otevřít
        </Button>
      );
    },
    disableSort: true,
  },
  {
    id: 'action',
    label: 'Akce',
    disableSort: true,
    CellComponent: LentTableActionCell,
  },
];

export const lentHistoryRegisteredColumns: TableColumn[] = [
  {
    id: 'archivalUnitReference.numericId',
    label: 'Identifikátor archiválie',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.archivalCollection.mark',
    label: 'Značka AS',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.summary',
    label: 'Obsah archiválie',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalUnitReference.timeRange',
    label: 'Časový rozsah',
    CellComponent: TableCellText,
  },
  {
    id: 'firstViewed',
    label: 'První nahlížení',
    CellComponent: TableCellDate,
  },
  {
    id: 'lastViewed',
    label: 'Poslední nahlížení',
    CellComponent: TableCellDate,
  },
  {
    id: 'latestPrivateCopy.id',
    label: 'Detail',
    CellComponent: function CopyLink({ allData }) {
      const publicCopyId = allData?.publicCopy?.id;
      const privateCopyId = allData?.latestPrivateCopy?.id;
      const url = publicCopyId
        ? `${process.env.PUBLIC_URL}/pomucky/1/${publicCopyId}`
        : `${process.env.PUBLIC_URL}/soukrome-archivalie/0/${privateCopyId}`;
      return (
        <Button
          variant="contained"
          color="primary"
          size="small"
          href={url}
          disabled={!publicCopyId && !privateCopyId}
        >
          Otevřít
        </Button>
      );
    },
    disableSort: true,
  },
];
